import React from 'react'
import ProductsTshirts from './ProductsTshirts'


export default function Tshirts() {
  return (
    <div>
        <ProductsTshirts/>
    </div>
  )
}
